import { CDN_URL_ICONS, CDN_URL_IMAGES } from '@/configs';
import { isProduction } from '@/utils/commons';
import useAnalyticsEventTracker, {
  AlphaActions,
  GameFiActions,
} from '@/utils/ga';
import { useEffect, useState } from 'react';
import s from './style.module.scss';

const APP_URL = isProduction()
  ? 'https://alpha.newbitcoincity.com'
  : 'https://alpha.dev.newbitcoincity.com';

export const Section1 = (): JSX.Element => {
  const gaEventTracker = useAnalyticsEventTracker();

  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setLoaded(true);
    }, 500);
  }, []);

  return (
    <div className={`${s.container}`}>
      <a
        href={'/join-alpha'}
        onClick={() => gaEventTracker(GameFiActions.ClickLearmoreMegaWheels)}
        className={`${s.wrapBanner}  ${loaded && s.wrapBanner_active}`}
      >
        <img
          className={s.banner}
          src={`${CDN_URL_IMAGES}/alpha_home_bg_03.jpg`}
        ></img>
        <div>
          {loaded && (
            <div className={s.wContent}>
              <div className={s.content}>
                <div className={s.row}>
                  {/* <img alt="small-nbc" src={`${CDN_URL_ICONS}/alpha.png`} /> */}
                  <p className={s.title}>Alpha</p>
                </div>
                <p className={s.desc}>
                  Say hello to the friend.tech of Bitcoin.
                </p>
                <div className={s.actions}>
                  <a
                    href={APP_URL}
                    onClick={() => gaEventTracker(AlphaActions.InstallAlphaApp)}
                    className={s.install}
                  >
                    <img
                      alt="mobile"
                      className={s.logo}
                      src={`${CDN_URL_ICONS}/mobile-install.svg`}
                    />
                    <p>Install the app</p>
                  </a>
                  <a className={s.wrap_link}>
                    <p>Learn more</p>
                  </a>
                </div>
              </div>
            </div>
          )}
        </div>
      </a>
    </div>
  );
};
